import { motion } from 'motion/react';
import { ArrowLeft } from 'lucide-react';
import { Button, Progress } from '@ideoz/ui';
import type { Step2Props } from '../types';
import { workOptions } from '../config/workOptions';
import { Badge } from './Badge';
import { IdeozLogo } from './IdeozLogo';

export function Step2({
  selectedWorkOption,
  onSelectWorkOption,
  onBack,
  onContinue,
}: Step2Props): JSX.Element {
  return (
    <motion.div
      key="step2"
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 20 }}
      transition={{ duration: 0.3 }}
      className="flex flex-col h-full"
    >
      <header className="flex flex-col gap-12">
        <div className="flex items-center gap-4">
          <motion.button
            onClick={onBack}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <ArrowLeft size={20} className="text-gray-700" />
          </motion.button>
          <IdeozLogo />
        </div>

        <div className="flex flex-col gap-3 items-start justify-center ">
          <h2 className="text-primary-900 font-semibold text-3xl">
            What do you want to work on first?
          </h2>
          <p className="text-gray-900 text-xl">Let's focus to help you quickly</p>
        </div>
      </header>

      <div className="flex flex-col gap-3 lg:mt-24 lg:mb-12 mt-12 mb-6">
        {workOptions.map((option) => (
          <motion.div
            key={option.value}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, delay: workOptions.indexOf(option) * 0.09 }}
            exit={{ opacity: 0 }}
          >
            <Badge
              text={option.label}
              isSelected={selectedWorkOption === option.value}
              onClick={() => onSelectWorkOption(option.value)}
            />
          </motion.div>
        ))}
      </div>

      <div className="flex justify-between items-center mt-auto">
        <div className="w-40 flex items-center gap-4">
          <Progress value={100} />
          <span className="text-sm text-gray-500">2/2</span>
        </div>
        <Button variant="primary" size="lg" onClick={onContinue} disabled={!selectedWorkOption}>
          Continue
        </Button>
      </div>
    </motion.div>
  );
}
